module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "login-form"
  }, [_c('el-col', [_c('img', {
    staticClass: "ii-logo",
    attrs: {
      "src": "/static/ii_logo.png"
    }
  }), _vm._v(" "), _c('el-card', {
    staticClass: "login_card"
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.logos),
      expression: "logos"
    }],
    staticClass: "client-logo",
    attrs: {
      "src": _vm.logos[_vm.host] || _vm.logos['insideinsight']
    }
  }), _vm._v(" "), (_vm.message) ? _c('el-alert', {
    attrs: {
      "title": _vm.message,
      "type": "error",
      "showicon": "",
      "closable": true
    }
  }) : _vm._e(), _vm._v(" "), _c('el-form', {
    attrs: {
      "label-position": "top"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.labels[0]
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.placeholders[0]
    },
    model: {
      value: (_vm.username),
      callback: function($$v) {
        _vm.username = $$v
      },
      expression: "username"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.forgotPassword),
      expression: "!forgotPassword"
    }],
    attrs: {
      "label": _vm.labels[1]
    }
  }, [_c('el-input', {
    attrs: {
      "type": _vm.host === 'staples' ? 'text' : 'password',
      "placeholder": _vm.placeholders[1]
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1), _vm._v(" "), (_vm.host === 'staples') ? _c('span', {
    attrs: {
      "id": "hint"
    }
  }, [_vm._v("Replace xxxx with your Store ID")]) : _vm._e(), _vm._v(" "), _c('el-form-item', [(_vm.host !== 'staples') ? _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.forgotPassword),
      expression: "!forgotPassword"
    }],
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.forgotPassword = true
      }
    }
  }, [_vm._v("\n            Forgot password? Click Here\n          ")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.forgotPassword),
      expression: "forgotPassword"
    }],
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.forgotPassword = false
      }
    }
  }, [_vm._v("\n            Return to login\n          ")])], 1), _vm._v(" "), _c('el-form-item', [(!_vm.forgotPassword) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.isAuthenticating
    },
    on: {
      "click": function($event) {
        _vm.authenticate({
          username: _vm.username,
          password: _vm.password
        })
      }
    }
  }, [_vm._v("\n            Sign In\n          ")]) : _vm._e(), _vm._v(" "), (!_vm.forgotPassword && _vm.urlConfig) ? _c('div', [_c('div', [_vm._v("OR")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "padding": "0"
    },
    on: {
      "click": _vm.googleAuthenticate
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/G-SIGN.png",
      "id": "dagger",
      "height": "50px"
    }
  })]), _vm._v(" "), _c('el-button', {
    attrs: {
      "loading": _vm.isAnonymousAuthenticating
    },
    on: {
      "click": function($event) {
        _vm.anonymousAuthenticate()
      }
    }
  }, [_vm._v("\n              Sign In As Guest\n            ")])], 1) : _vm._e(), _vm._v(" "), (_vm.forgotPassword) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.isSendingLink
    },
    on: {
      "click": function($event) {
        _vm.sendResetLink(_vm.username)
      }
    }
  }, [_vm._v("\n              Send Reset Link\n          ")]) : _vm._e()], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-07c210c0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Forms/LoginForm.vue
// module id = 480
// module chunks = 6